import { ReactComponent as IconStore } from "@common_assets/svg/store.svg"
import { Button, Stack, Typography } from "@mui/material"
import { HREFLINK } from "components/common/link/hreflink"
import { useCustomPayment } from "hooks/payment"
import { Trans, useTranslation } from "react-i18next"

const GroupsUpgradePrompt = () => {
  const { t } = useTranslation()
  const { payIt, isLoadingPayments } = useCustomPayment()

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      gap="8px"
      width="100%"
      maxWidth={{ desktop: "800px" }}
      mx="auto"
      minHeight={{
        mobile: "calc(100vh - 240px)",
        tablet: "calc(100vh - 260px)",
        desktop: "calc(100vh - 340px)",
      }}
      p="32px"
      border={(theme) => `2px solid ${theme.palette.mockup.primary95}`}
      borderRadius="16px"
      bgcolor={(theme) => theme.palette.common.white}
    >
      <IconStore />
      <Typography variant="h3" color="mockup.darkBlue">
        {t("group.upgradeTitle")}
      </Typography>
      <Typography variant="body2" color="mockup.neutral40" maxWidth="440px">
        <Trans
          i18nKey="group.upgradePlansNote"
          components={{
            Link: HREFLINK,
          }}
        />
      </Typography>
      <Button
        onClick={() => payIt(null)}
        disabled={isLoadingPayments}
        sx={{ mt: "16px" }}
      >
        {t("group.upgradeCta")}
      </Button>
    </Stack>
  )
}

export default GroupsUpgradePrompt
